(() => {
  const embedSelector = '.rz-password-capture__app-block shopify-forms-embed';
  const consentCopy = 'I agree to receive Ritual Zone emails and recurring automated texts.';
  const styleId = 'rz-password-form-styles';

  const initializePolicyDialogs = () => {
    document.querySelectorAll('[data-rz-policy-open]').forEach((trigger) => {
      if (trigger.dataset.rzPolicyReady === 'true') return;

      trigger.dataset.rzPolicyReady = 'true';
      trigger.addEventListener('click', () => {
        const policy = trigger.dataset.rzPolicyOpen;
        const dialog = document.querySelector(`[data-rz-policy="${policy}"]`);

        if (!dialog) return;

        dialog.__rzPolicyOpener = trigger;
        dialog.showModal();
      });
    });

    document.querySelectorAll('.rz-password-policy').forEach((dialog) => {
      if (dialog.dataset.rzPolicyReady === 'true') return;

      dialog.dataset.rzPolicyReady = 'true';
      dialog.querySelector('[data-rz-policy-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => dialog.__rzPolicyOpener?.focus());
    });
  };

  const enhanceRoot = (root) => {
    if (!root) return;

    if (!root.getElementById(styleId)) {
      const style = document.createElement('style');
      style.id = styleId;
      style.textContent = `
        form[data-testid='form'] {
          text-align: left !important;
        }

        form[data-testid='form'] fieldset[name^='custom#'] {
          width: 100% !important;
          text-align: left !important;
        }

        form[data-testid='form'] fieldset[name^='custom#'] > legend {
          position: absolute !important;
          width: 1px !important;
          height: 1px !important;
          padding: 0 !important;
          margin: -1px !important;
          overflow: hidden !important;
          clip: rect(0, 0, 0, 0) !important;
          white-space: nowrap !important;
          border: 0 !important;
        }

        form[data-testid='form'] fieldset[name^='custom#'] label {
          display: grid !important;
          grid-template-columns: 13px minmax(0, 1fr) !important;
          align-items: start !important;
          column-gap: 0.75rem !important;
          text-align: left !important;
        }

        form[data-testid='form'] fieldset[name^='custom#'] label > div:first-child {
          align-self: start !important;
          margin-top: 0.2rem !important;
        }

        form[data-testid='form'] fieldset[name^='custom#'] label > span {
          line-height: 1.45 !important;
          text-align: left !important;
        }

        input,
        select,
        textarea,
        button[data-testid='btn-form-submit'] {
          border-radius: 0 !important;
        }

        button[data-testid='btn-form-submit'] {
          font-family: 'Neue Power', sans-serif !important;
          font-size: 0.875rem !important;
          font-weight: 500 !important;
          letter-spacing: 0 !important;
          text-transform: uppercase !important;
        }

        form[data-testid='form'] + div {
          text-align: left !important;
        }
      `;
      root.append(style);
    }

    const consentField = root.querySelector("form[data-testid='form'] fieldset[name^='custom#']");
    const consentLabel = consentField?.querySelector('label');
    const consentText = consentLabel?.querySelector(':scope > span');
    const consentInput = consentLabel?.querySelector("input[type='checkbox']");

    if (consentText && consentText.textContent !== consentCopy) {
      consentText.textContent = consentCopy;
    }

    if (consentInput) {
      consentInput.setAttribute('aria-label', consentCopy);
    }
  };

  const enhance = () => {
    const embed = document.querySelector(embedSelector);
    const root = embed?.shadowRoot;

    if (!root) return false;

    enhanceRoot(root);

    if (!root.__rzPasswordObserver) {
      const rootObserver = new MutationObserver(() => enhanceRoot(root));
      rootObserver.observe(root, { childList: true, subtree: true });
      root.__rzPasswordObserver = rootObserver;
    }

    return true;
  };

  const pageObserver = new MutationObserver(enhance);
  pageObserver.observe(document.documentElement, { childList: true, subtree: true });

  const retry = window.setInterval(() => {
    if (enhance()) window.clearInterval(retry);
  }, 100);

  window.setTimeout(() => window.clearInterval(retry), 10000);
  document.addEventListener('shopify:section:load', enhance);
  document.addEventListener('shopify:section:load', initializePolicyDialogs);
  initializePolicyDialogs();

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.rz-password-capture__video').forEach((video) => video.pause());
  }
})();
